export default __webpack_public_path__ + "static/media/CaretRight.d1a57b57.png";